import { Schema } from '@typings';

export const isSchemaAnyOf = (schema: Schema.Model): schema is Schema.AnyOf =>
  schema.type === Schema.Type.AnyOf;

export const isSchemaContainer = (
  schema: Schema.Model,
): schema is Schema.Container => schema.type === Schema.Type.Container;

export const isSchemaField = (schema: Schema.Model): schema is Schema.Field =>
  schema.type === Schema.Type.Field;

export const isSchemaArray = (schema: Schema.Model): schema is Schema.Array =>
  schema.type === Schema.Type.Array;

export const isSchemaWithChildren = (
  model: Schema.Model,
): model is Schema.ModelWithChildren => {
  return ![Schema.Type.Field, Schema.Type.Array].includes(model.type);
};
